import { motion, useReducedMotion } from 'motion/react'
import type { ReactNode } from 'react'

export interface StoryNavigationButtonProps {
	className: string
	label: string
	disabled: boolean
	children: ReactNode
	onClick: () => void
}

export default function StoryNavigationButton({
	className,
	label,
	disabled,
	children,
	onClick,
}: StoryNavigationButtonProps) {
	const prefersReducedMotion = useReducedMotion()

	return (
		<motion.button
			type="button"
			className={className}
			aria-label={label}
			disabled={disabled}
			initial={false}
			animate={{ opacity: disabled ? 0.28 : 1 }}
			whileTap={disabled || prefersReducedMotion ? undefined : { scale: 0.95 }}
			transition={{
				opacity: { duration: prefersReducedMotion ? 0 : 0.16, ease: 'easeOut' },
				scale: prefersReducedMotion
					? { duration: 0 }
					: { type: 'spring', stiffness: 500, damping: 30 },
			}}
			onClick={onClick}
		>
			{children}
		</motion.button>
	)
}
